import { TRANSACTION_HISTORY } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { TravelSimRegistrationRequestModel } from "features/travelSimRegistration/data/model/TravelSimRegistrationRequestModel";
import { TravelSimRegistrationResponseModel } from "features/travelSimRegistration/data/model/TravelSimRegistrationResponseModel";
import { ITravelSimRegistrationRepository } from "features/travelSimRegistration/domain/repositories/ITravelSimRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";

@injectable()
export class TravelSimRegistrationImpl implements ITravelSimRegistrationRepository {
  async getOutboundList(
    params: TravelSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<TravelSimRegistrationRequestModel>(
      TRANSACTION_HISTORY.OUTBOUNDLIST,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getInboundList(
    params: TravelSimRegistrationRequestModel,
  ): Promise<ListBaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<TravelSimRegistrationRequestModel>(
      TRANSACTION_HISTORY.INBOUNDLIST,
      params,
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: TravelSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<TravelSimRegistrationResponseModel>> {
    return await client.get(
      `${TRANSACTION_HISTORY.INBOUNDLIST}/${params?.code}`,
    );
  }

  async inboundExportReport(
    params: TravelSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.INBOUNDLIST,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }

  async outboundExportReport(
    params: TravelSimRegistrationRequestModel,
  ): Promise<BaseApiResponseModel<Blob>> {
    delete params?.typeofSim;
    const url = StringFormat.buildExportUrl(
      TRANSACTION_HISTORY.OUTBOUNDLIST,
      params,
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      getMessage(errorBody["message"], 3, "error");
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
